var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Document Type","items":_vm.items,"item-text":"label","item-value":"code","outlined":_vm.outlined},on:{"change":_vm.onChange},model:{value:(_vm.templateType),callback:function ($$v) {_vm.templateType=$$v},expression:"templateType"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-284a9319","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/admin/documents/DocumtTemplateTypeSelect.vue
// module id = null
// module chunks = 